/* Novaa Gear PDP — interactive bits.
   Pure vanilla, no deps. Safe to load with defer. */
(function () {
  'use strict';
  if (window.__novaaPdpInit) return;
  window.__novaaPdpInit = true;

  // ----- Helpers -----
  // Resize a Shopify CDN image URL to a target width.
  function atWidth(url, w) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  // Pull the url(...) out of an element's background-image.
  function bgUrl(el) {
    if (!el) return '';
    var bg = (el.style && el.style.backgroundImage) || '';
    if (!bg || bg === 'none') { try { bg = getComputedStyle(el).backgroundImage || ''; } catch (e) {} }
    var m = bg.match(/url\(["']?(.*?)["']?\)/);
    return m ? m[1] : '';
  }

  // ----- Lightbox (click-to-enlarge) -----
  function ensureLightboxStyles() {
    if (document.getElementById('nv-lightbox-styles')) return;
    var s = document.createElement('style');
    s.id = 'nv-lightbox-styles';
    s.textContent =
      '.nv-lightbox{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;background:rgba(12,14,16,.92);padding:24px;opacity:0;transition:opacity .2s ease;cursor:zoom-out}' +
      '.nv-lightbox.is-on{opacity:1}' +
      '.nv-lightbox img{max-width:95vw;max-height:92vh;width:auto;height:auto;object-fit:contain;box-shadow:0 20px 60px -20px rgba(0,0,0,.6)}' +
      '.nv-lightbox-close{position:fixed;top:18px;right:22px;width:44px;height:44px;background:none;border:0;color:#fff;font-size:34px;line-height:1;cursor:pointer}';
    document.head.appendChild(s);
  }
  function openLightbox(url) {
    if (!url) return;
    ensureLightboxStyles();
    var ov = document.createElement('div');
    ov.className = 'nv-lightbox';
    var btn = document.createElement('button');
    btn.className = 'nv-lightbox-close';
    btn.setAttribute('aria-label', 'Close');
    btn.innerHTML = '&times;';
    var img = document.createElement('img');
    img.src = url; img.alt = '';
    ov.appendChild(btn);
    ov.appendChild(img);
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add('is-on'); });
    function close() {
      ov.classList.remove('is-on');
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 200);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  // ----- Gallery: thumb click swaps the main image / plays video + click-to-enlarge -----
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.main');
    var mainVideo = g.querySelector('[data-main-video]');
    var thumbs = g.querySelectorAll('.thumb');

    function clearVideo() {
      if (mainVideo) {
        var ex = mainVideo.querySelector('video');
        if (ex) { try { ex.pause(); } catch (e) {} }
        mainVideo.innerHTML = '';
        mainVideo.hidden = true;
      }
      if (main) main.classList.remove('is-video');
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');

        var type = t.getAttribute('data-media-type');
        var vref = t.getAttribute('data-video-ref');
        if (type === 'video' && vref) {
          var tpl = g.querySelector('template[data-video-tpl="' + vref + '"]');
          if (tpl && mainVideo) {
            mainVideo.innerHTML = '';
            mainVideo.appendChild(tpl.content.cloneNode(true));
            mainVideo.hidden = false;
            if (main) main.classList.add('is-video');
            var v = mainVideo.querySelector('video');
            if (v) { try { v.play(); } catch (e) {} }
          }
          return;
        }

        // image thumb — restore the still viewer
        clearVideo();
        var src = t.getAttribute('data-full') || bgUrl(t.querySelector('.ph'));
        if (src && main) {
          main.style.backgroundImage = "url('" + atWidth(src, 1400) + "')";
          main.style.backgroundSize = 'cover';
          main.style.backgroundPosition = 'center';
        }
        var label = t.dataset.label || '';
        var lbl = main && main.querySelector('.ph-label');
        if (lbl) lbl.textContent = label;
      });
    });

    // Prev / next arrows on the main viewer — step through every media item.
    var navBtns = g.querySelectorAll('[data-nav]');
    function goRel(dir) {
      if (!thumbs.length) return;
      var idx = 0;
      for (var i = 0; i < thumbs.length; i++) { if (thumbs[i].classList.contains('is-active')) { idx = i; break; } }
      var n = (idx + dir + thumbs.length) % thumbs.length;
      thumbs[n].click();
    }
    navBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        goRel(b.getAttribute('data-nav') === 'next' ? 1 : -1);
      });
    });

    if (main) {
      var hasImg = !!bgUrl(main) || !!main.getAttribute('style');
      if (hasImg) {
        main.style.cursor = 'zoom-in';
        main.addEventListener('click', function (e) {
          if (main.classList.contains('is-video')) return;         // don't enlarge while the video is showing
          if (mainVideo && mainVideo.contains(e.target)) return;   // clicks on the video/controls stay in the player
          openLightbox(atWidth(bgUrl(main), 2048));
        });
      }
    }
  });

  // ----- Quantity stepper -----
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var v = q.querySelector('.v');
    q.querySelector('[data-qty-minus]').addEventListener('click', function () {
      var n = Math.max(1, parseInt(v.textContent, 10) - 1);
      v.textContent = n;
    });
    q.querySelector('[data-qty-plus]').addEventListener('click', function () {
      var n = Math.min(9, parseInt(v.textContent, 10) + 1);
      v.textContent = n;
    });
  });

  // ----- Bundle picker mirror to mobile buybar -----
  function syncBundleName() {
    var checked = document.querySelector('input[name="bundle"]:checked');
    if (!checked) return;
    var label = checked.closest('.opt').querySelector('.opt-name').textContent.trim();
    var price = checked.closest('.opt').querySelector('.opt-price').textContent.trim();
    document.querySelectorAll('[data-bb-name]').forEach(function (el) { el.textContent = label; });
    document.querySelectorAll('[data-bb-price]').forEach(function (el) { el.textContent = price; });
  }
  document.querySelectorAll('input[name="bundle"]').forEach(function (i) {
    i.addEventListener('change', syncBundleName);
  });
  syncBundleName();

  // ----- Fitment mini-check -----
  var fc = document.querySelector('[data-fitcheck]');
  if (fc) {
    var verdict = fc.querySelector('.verdict');
    var answers = {};
    fc.querySelectorAll('.q-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.dataset.q;
        var a = b.dataset.a;
        answers[q] = a;
        // toggle active state within question
        b.parentElement.querySelectorAll('.q-opt').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');

        var keys = Object.keys(answers);
        if (keys.length >= 3) {
          // simple rule for 200 Series: door spare = no (LC200 doesn't have one),
          // tank yes = recommend mid (P2), tow bar oem = fine
          var msg = '';
          var warn = false;
          if (answers.tank === 'yes') {
            msg = 'Position 1 (50mm) sits clear of the long-range tank fitments we’ve seen on the 200. The wheel holder finally has a home.';
          } else {
            msg = 'Standard 200 Series fitment — Position 1 (50mm) or Position 2 (90mm) gives clean clearance under the rear hatch.';
          }
          if (answers.towbar === 'aftermarket-tall') {
            warn = true;
            msg = 'Tall aftermarket tow bars sit higher than factory. Send a rear photo — we’ll confirm hitch height before you order.';
          }
          verdict.classList.add('is-on');
          verdict.querySelector('p').textContent = msg;
          var lbl = verdict.querySelector('.v-label');
          if (warn) { lbl.classList.add('warn'); lbl.firstChild.nextSibling && (lbl.querySelector('.txt').textContent = 'WORTH A QUICK PHOTO'); }
          else      { lbl.classList.remove('warn'); lbl.querySelector('.txt').textContent = 'FITS YOUR RIG'; }
        }
      });
    });
  }

  // ----- Sticky mobile buy bar (appears after hero ATC leaves viewport) -----
  var sentinel = document.querySelector('[data-atc-sentinel]');
  var bar = document.querySelector('[data-buybar]');
  if (sentinel && bar) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top < 0) bar.classList.add('is-on');
        else bar.classList.remove('is-on');
      });
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  // ----- Live variant controller (postMessage from review wrapper) -----
  function applyVariant(v) {
    // Rigs gallery layout
    if (v.rigs) {
      var rg = document.querySelector('[data-rigs]');
      if (rg) {
        rg.classList.remove('layout-scroller', 'layout-grid', 'layout-masonry');
        rg.classList.add('layout-' + v.rigs);
      }
    }
    // Mobile buy bar style
    if (v.buybar) {
      var bb = document.querySelector('[data-buybar]');
      if (bb) {
        bb.classList.remove('style-default', 'style-compact', 'style-off');
        bb.classList.add('style-' + v.buybar);
      }
    }
    // Fitment mode (notes / check / photo / all)
    if (v.fit) {
      var notes = document.querySelector('.fit-notes');
      var check = document.querySelector('.fit-check');
      var photo = document.querySelector('.fit-photo');
      [notes, check, photo].forEach(function (el) { if (el) el.style.display = ''; });
      if (v.fit === 'notes') { if (check) check.style.display = 'none'; if (photo) photo.style.display = 'none'; }
      else if (v.fit === 'check') { if (notes) notes.style.display = 'none'; if (photo) photo.style.display = 'none'; }
      else if (v.fit === 'photo') { if (notes) notes.style.display = 'none'; if (check) check.style.display = 'none'; }
      // 'all' shows everything
    }
  }

  // Apply from URL on load
  var params = new URLSearchParams(location.search);
  applyVariant({
    rigs: params.get('rigs'),
    buybar: params.get('buybar'),
    fit: params.get('fit')
  });

  // Listen for postMessage tweaks
  window.addEventListener('message', function (e) {
    if (e.data && e.data.type === 'pdp-variant') applyVariant(e.data.variant || {});
  });

})();
